// extracted by mini-css-extract-plugin
export default {"main":"Background_main__KkfzS","bgy":"Background_bgy__EBbRZ","bgg":"Background_bgg__3vlF-","slogan":"Background_slogan__IjKtp"};